import { Building2 } from 'lucide-react';
import { Link } from 'react-router-dom';
import NewsletterForm from './NewsletterForm';
import { useTranslation, useLanguage } from '../i18n';

export default function Footer() {
  const { t } = useTranslation();
  const { getLocalizedPath } = useLanguage();

  return (
    <footer className="relative bg-[#0E0A31] border-t border-white/10 py-16 px-4 sm:px-6 lg:px-8">
      <div className="max-w-7xl mx-auto relative z-10">
        <div className="mb-12 pb-12 border-b border-white/10">
          <div className="max-w-2xl">
            <h3 className="text-2xl font-bold text-white mb-2">{t.footer.newsletter.title}</h3>
            <p className="text-gray-400 mb-6">{t.footer.newsletter.description}</p>
            <NewsletterForm variant="footer" />
          </div>
        </div>
        <div className="grid md:grid-cols-4 gap-12 mb-12">
          <div>
            <div className="mb-6">
              <img
                src="/grayscale_transparent_nobuffer.png"
                alt="ControlMax"
                className="h-12 w-auto"
                width={156}
                height={48}
                loading="lazy"
              />
            </div>
            <p className="text-gray-400 text-sm leading-relaxed">
              {t.footer.tagline}
            </p>
          </div>
          <div>
            <h4 className="font-bold text-white mb-4">{t.footer.solutions}</h4>
            <ul className="space-y-3 text-sm">
              <li><Link to={getLocalizedPath('/hr-pontaj')} className="text-gray-400 hover:text-blue-400 transition-colors">{t.nav.hrPontaj}</Link></li>
              <li><Link to={getLocalizedPath('/logistica')} className="text-gray-400 hover:text-blue-400 transition-colors">{t.nav.logistics}</Link></li>
              <li><Link to={getLocalizedPath('/achizitii')} className="text-gray-400 hover:text-blue-400 transition-colors">{t.nav.procurement}</Link></li>
              <li><Link to={getLocalizedPath('/echipamente')} className="text-gray-400 hover:text-blue-400 transition-colors">{t.nav.equipment}</Link></li>
              <li><Link to={getLocalizedPath('/documente')} className="text-gray-400 hover:text-blue-400 transition-colors">{t.nav.documents}</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-bold text-white mb-4">{t.footer.company}</h4>
            <ul className="space-y-3 text-sm">
              <li><Link to={getLocalizedPath('/despre')} className="text-gray-400 hover:text-blue-400 transition-colors">{t.nav.about}</Link></li>
              <li><Link to={getLocalizedPath('/contact')} className="text-gray-400 hover:text-blue-400 transition-colors">{t.nav.contact}</Link></li>
              <li><Link to={getLocalizedPath('/blog')} className="text-gray-400 hover:text-blue-400 transition-colors">{t.nav.blog}</Link></li>
              <li><Link to={getLocalizedPath('/newsletter')} className="text-gray-400 hover:text-blue-400 transition-colors">Newsletter</Link></li>
            </ul>
          </div>
          <div>
            <h4 className="font-bold text-white mb-4">{t.footer.legal}</h4>
            <ul className="space-y-3 text-sm">
              <li><Link to={getLocalizedPath('/termeni')} className="text-gray-400 hover:text-blue-400 transition-colors">{t.footer.terms}</Link></li>
              <li><Link to={getLocalizedPath('/confidentialitate')} className="text-gray-400 hover:text-blue-400 transition-colors">{t.footer.privacy}</Link></li>
              <li><Link to={getLocalizedPath('/gdpr')} className="text-gray-400 hover:text-blue-400 transition-colors">{t.footer.gdpr}</Link></li>
            </ul>
          </div>
        </div>
        <div className="border-t border-white/10 pt-8 flex flex-col md:flex-row justify-between items-center">
          <p className="text-gray-400 text-sm">&copy; 2026 ControlMax. {t.footer.rights}</p>
          <div className="flex items-center space-x-6 mt-4 md:mt-0">
            <a href="https://www.facebook.com/profile.php?id=61570338142204" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-cyan-400 transition-colors">Facebook</a>
            <a href="https://www.instagram.com/_controlmax/" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-cyan-400 transition-colors">Instagram</a>
            <a href="https://www.linkedin.com/company/105738627" target="_blank" rel="noopener noreferrer" className="text-gray-400 hover:text-cyan-400 transition-colors">LinkedIn</a>
          </div>
        </div>
      </div>
    </footer>
  );
}
